/** THIS IS AN AUTO GENERATED FILE, DO NOT EDIT MANUALLY -- Created by @graphql-codegen */
import * as Types from '../../shared/generated.types'

import { api } from '../../utils'
export const AuditEntryFragment = `
    fragment AuditEntryFragment on AuditEntry {
  date
  reference {
    id
    type
    display
  }
}
    `
export const ActionEntryFragment = `
    fragment ActionEntryFragment on ActionEntry {
  author {
    ...AuditEntryFragment
  }
  code
  description
}
    `
export const EligibilityVerificationV2Frag = `
    fragment EligibilityVerificationV2Frag on EligibilityVerificationV2 {
  id
  billingInsuranceId
  ts
  payerId
  providerName
  providerNpi
  location
  insured {
    patientRelationship
    firstName
    lastName
    dob
    dateOfServiceStart
    dateOfServiceEnd
    memberId
  }
  vendor
  isActive
  benefitSummaryPdfFile
  requestId
  insurancePlanId
  coPay
  deductible
  familyDeductible
  coinsurance
  note
  actionLog {
    ...ActionEntryFragment
  }
}
    `
export const VerifyEligibilityDocument = `
    mutation verifyEligibility($input: VerifyEligibilityInputV2!) {
  verifyEligibility(input: $input) {
    ...EligibilityVerificationV2Frag
  }
}
    ${EligibilityVerificationV2Frag}
${ActionEntryFragment}
${AuditEntryFragment}`
export const VerifyEligibilityFromEmrDocument = `
    mutation verifyEligibilityFromEmr($input: VerifyEligibilityFromEmrInput!) {
  verifyEligibilityFromEmr(input: $input) {
    ...EligibilityVerificationV2Frag
  }
}
    ${EligibilityVerificationV2Frag}
${ActionEntryFragment}
${AuditEntryFragment}`

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    verifyEligibility: build.mutation<
      Types.VerifyEligibility,
      Types.VerifyEligibilityVariables
    >({
      query: (variables) => ({
        document: VerifyEligibilityDocument,
        variables,
      }),
    }),
    verifyEligibilityFromEmr: build.mutation<
      Types.VerifyEligibilityFromEmr,
      Types.VerifyEligibilityFromEmrVariables
    >({
      query: (variables) => ({
        document: VerifyEligibilityFromEmrDocument,
        variables,
      }),
    }),
  }),
})

export { injectedRtkApi as api }
